<template>
	<div class="flow">
		<div class="content">
			<div class="title">药销通核心应用</div>
			<div class="steps flex-row flex-center"> <img :src="ImgUrl" alt=""></div>
			<div class="bottom"></div>
		</div>
	</div>
</template>

<script>
export default {
	methods: {},
	data() {
		return {
			ImgUrl:require('@/assets/home/kernel.png'),
		};
	}
};
</script>

<style lang="scss" scoped>
.steps {
	width: 100%;
	height: 500px;
	// background-color: white;
	img{
		width: 1200px;
	}
}
.bottom {
	height: 80px;
}

.content::before {
	content: '';
	display: table;
}
.title {
	margin: 0 auto;
	text-align: center;
	height: 45px;
	text-align: center;
	font-size: 32px;
	font-weight: 600;
	color: #333333;
	line-height: 45px;
	margin-top: 82px;
	margin-bottom: 80px;
}
.flow {
	margin-top: 105px;
	background-color: $global-default-opacity-background;
}
.content {
	margin: 0 auto;
	width: $global-content-width;
}
</style>
